import React from 'react'
import {Container, Navbar, Nav, Offcanvas} from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import {Logo} from '../Logo/Logo'

const SadatJobsNavbar: React.FC = ({children}) => {
    return (
            <Navbar className='navbar navbar-dark bg-dark' expand={false}>
                <Container fluid>
                    <div className={'mx-auto'} style={{paddingLeft: 40}}>
                        <NavLink to={'/'}>
                            <Logo/>
                        </NavLink>
                    </div>
                    <Navbar.Toggle aria-controls="offcanvasNavbar"/>
                    <Navbar.Offcanvas
                            id="offcanvasNavbar"
                            aria-labelledby="offcanvasNavbarLabel"
                            placement="end"
                            style={{backgroundColor: '#1D252D'}}
                    >
                        <Offcanvas.Header closeButton className='navbar-light btn-close-white'>
                            <Offcanvas.Title id="offcanvasNavbarLabel"></Offcanvas.Title>
                        </Offcanvas.Header>
                        <Logo/>
                        <Offcanvas.Body style={{backgroundColor: '#1D252D'}}>
                            <Nav className="justify-content-end flex-grow-1 pe-3" style={{paddingTop: 20}}>
                                {children}
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
    )
}
export default SadatJobsNavbar